<template>
  <vs-popup background-color-popup="#F1F1F1" class="holamundo" title="Sipariş Kalemi Logları" :active.sync="isActive"
            v-esc="escape">
    <vs-row id="approveLogContent" vs-type="flex" vs-w="12">
      <vs-row vs-type="block" vs-w="12" v-if="approveLogs.length > 0" class="mb-2 bg-white p-3" vs-justify="center">
        <span class="d-block text-small text-center text-dark weight-600">
          {{ approveLogs[0].name }}
        </span>
        <vs-divider></vs-divider>
        <div class="d-flex w-full justify-center align-center">
          <span class="text-small text-primary weight-600">
          {{ approveLogs.reduce((x, y) => x + y.quantity, 0) }}
        </span>
          <span class="ml-1 text-smaller text-dark weight-600">
          x {{ approveLogs[0].unit.name }}
        </span>
        </div>
      </vs-row>
      <vs-row id="approveLogHeader" vs-type="flex" vs-w="12">
        <vs-col vs-type="flex" vs-w="4" vs-justify="center" vs-align="center" class="p-1">
          <span class="text-primary text-smaller weight-600">
            Miktar
          </span>
        </vs-col>
        <vs-col vs-type="flex" vs-w="5" vs-justify="center" vs-align="center" class="p-1">
          <span class="text-primary text-smaller weight-600">
            Gönd. Tarihi
          </span>
        </vs-col>
        <vs-col vs-type="flex" vs-w="3" vs-justify="center" vs-align="center" class="p-1">
          <span class="text-primary text-smaller weight-600">
            Durum
          </span>
        </vs-col>
      </vs-row>
      <vs-row id="approveLogs" vs-type="flex" vs-w="12">
        <vs-row class="approveLogEntry p-1" vs-type="flex" vs-w="12" v-for="(entry,index) in approveLogs" :key="index"
                :class="{'bg-white' : index % 2 == 0,'bg-secondary2' : index % 2 == 1}">
          <vs-col vs-type="flex" vs-w="4" vs-justify="center" vs-align="center" class="py-1 px-2">
            <span class="text-dark text-small text-center weight-600">
              {{ entry.quantity }}
            </span>
          </vs-col>
          <vs-col vs-type="flex" vs-w="5" vs-justify="center" vs-align="center" class="py-1 px-2">
            <span class="text-dark text-smaller text-center weight-600">
              {{ entry.created }}
            </span>
          </vs-col>
          <vs-col vs-type="flex" vs-w="3" vs-justify="center" vs-align="center" class="py-1 px-2">
            <span v-if="entry.isCommited" class="text-success text-smaller weight-600">
              Ulaştı !
            </span>
            <span v-else class="text-warning text-smaller weight-600">
              Ulaşmadı !
            </span>
          </vs-col>
        </vs-row>
      </vs-row>
    </vs-row>
  </vs-popup>
</template>

<script>
import {
  getEntryApproveLogs
} from "@/api/StockOrder";

export default {
  props: {
    stockOrderEntryId: {
      required: true,
      type: Number
    }
  },
  data() {
    return {
      approveLogs: []
    }
  },
  computed: {
    isActive: {
      get() {
        return this.stockOrderEntryId != 0 && this.stockOrderEntryId != null ? true : false;
      },
      set(val) {
        this.$emit("close");
      }
    }
  },
  methods: {
    escape() {
      if (this.isActive == true) {
        this.isActive = false;
      }
    },
    getEntryApproveLogs(entryId) {
      getEntryApproveLogs(entryId).then(res => {
        if (res && res.status == 200) {
          this.approveLogs = res.data;
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Sipariş Kalem Logları Hata :" + res.status,
            text: "Loglara Erişilemedi !"
          });
        }
      }).catch(error => {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Sunucu Bağlantı Hatası !"
        });
      });
    }
  },
  watch: {
    stockOrderEntryId(val) {
      if (val == null) return;
      this.getEntryApproveLogs(val);
    }
  }
}

</script>

<style>

</style>
